import DynamicTabs from "../../data/DynamicTable/DynamicTabs";
import * as horizontalComponentsMap from "../Component/HorizontalTabComponents";

const HorizontalTab = () => {
  const rightId = localStorage.getItem("RightIdFromSidebar");

  const isAssetFinanceCustomer = parseInt(localStorage.getItem("IsAssetFinanceCustomer"));
  const isDeviceCustomer = parseInt(localStorage.getItem("IsDeviceCustomer"));

  // Map: flag value === "1" -> which tab key(s) to strip out
  const tabsToHide = [];
  if (isAssetFinanceCustomer === 1) {
    tabsToHide.push("CustomerDevices");// <-- match the exact key used in horizontalComponentsMap
  }
  if (isDeviceCustomer === 1) {
    tabsToHide.push("CollateralAssets"); // <-- match the exact key used in horizontalComponentsMap
  }

  // Build a filtered copy of the components map, excluding hidden tabs
  const filteredComponentsMap = Object.fromEntries(
    Object.entries(horizontalComponentsMap).filter(
      ([tabKey]) => !tabsToHide.includes(tabKey)
    )
  );

  return (
    <div className="container-fluid">
      <DynamicTabs
        rightId={rightId}
        componentsMap={filteredComponentsMap}
        showIcons
      />
    </div>
  );
};

export default HorizontalTab;